/* eslint-disable @typescript-eslint/no-explicit-any */

import {
    FetchBaseQueryMeta,
    createApi,
    fetchBaseQuery,
} from '@reduxjs/toolkit/query/react';
import { Mutex } from 'async-mutex';
import type { RootState } from '@src/store/store';
import { logout, setNewToken } from '@src/store/user/userSlice';
import { authService } from '../auth/authService';
// import { useAuth0 } from '@auth0/auth0-react';
import { useDispatch } from 'react-redux';

export interface ResponseData {
    [key: string]: unknown;
}

export enum Environment {
    STAGING = 'staging',
    PROD = 'prod',
}

export type QueryReturnValue<T = unknown, E = unknown, M = unknown> =
    | {
          error: E;
          data?: undefined;
          meta?: M;
      }
    | {
          error?: undefined;
          data: T;
          meta?: M;
      };

export type FetchQueryError = {
    status: number;
    statusCode?: number;
    message?: string[];
    error?: string;
    data?: {
        error?: string;
        erros?: unknown[];
    };
};

type Result = QueryReturnValue<
    ResponseData | null | undefined,
    FetchQueryError,
    FetchBaseQueryMeta
>;

const mutex = new Mutex();
export const environment = process.env.REACT_APP_ENV as Environment | undefined;

const baseQuery = fetchBaseQuery({
    baseUrl:
        environment === Environment.STAGING
            ? process.env.REACT_APP_API_BASE_URL
            : process.env.REACT_APP_API_PROD_BASE_URL,
    prepareHeaders: (headers, { getState }) => {
        const user = (getState as () => RootState)().user.user;
        if (user?.accessToken) {
            headers.set('authorization', `Bearer ${user.accessToken}`);
        }

        return headers;
    },
});
// const { logout: authLogout } = useAuth0();
// const dispatch = useDispatch();
const baseQueryWithReauth = async (
    args: any,
    api: any,
    extraOptions: any
): Promise<Result> => {
    // wait until the mutex is available without locking it
    await mutex.waitForUnlock();
    let result = await baseQuery(args, api, extraOptions);

    if (result.error && result.error.status === 401) {
        if (!mutex.isLocked()) {
            const release = await mutex.acquire();

            try {
                const newToken = await authService.getTokenSilently();
                if (newToken) {
                    api.dispatch(setNewToken(newToken));
                    // retry the initial query
                    result = await baseQuery(args, api, extraOptions);
                } else {
                    api.dispatch(logout(undefined));
                    // dispatch(logout(undefined));
                    // authLogout({
                    //     logoutParams: {
                    //         returnTo: window.location.origin,
                    //     },
                    // });
                }
            } catch (err) {
                api.dispatch(logout(undefined));
                // dispatch(logout(undefined));
                // authLogout({
                //     logoutParams: {
                //         returnTo: window.location.origin,
                //     },
                // });
            } finally {
                // release must be called once the mutex should be released again.
                release();
            }
        } else {
            // wait until the mutex is available without locking it
            await mutex.waitForUnlock();
            result = await baseQuery(args, api, extraOptions);
        }
    }
    return result as Result;
};

export const apiSlice = createApi({
    baseQuery: baseQueryWithReauth,
    tagTypes: ['Profile', 'Cart', 'PayoutSettings'],
    endpoints: () => ({}),
});
